import { createSlice } from '@reduxjs/toolkit'

import { fetchUsesList } from 'apps/applications/actions/installedApplicationsActions'
import { APPLICATION_UPDATE_MODAL_CLOSE } from 'apps/applications/constants/InstalledApplicationsReduxActionTypes'
import { UsesListState } from 'common/actions/integrations/Applications/interfaces'

const initialState: UsesListState = { fetching: false, applicationId: null, entities: null }

const usesListSlice = createSlice({
  name: 'usesList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsesList.pending, (state, action) => {
        state.fetching = true
        state.applicationId = action.meta.arg
      })
      .addCase(fetchUsesList.rejected, (state) => {
        state.fetching = false
        state.applicationId = null
        state.entities = null
      })
      .addCase(fetchUsesList.fulfilled, (state, action) => {
        state.fetching = false
        state.applicationId = action.meta.arg
        state.entities = action.payload
      })
      .addCase(APPLICATION_UPDATE_MODAL_CLOSE, () => {
        return initialState
      })
  },
})

export const usesListReducer = usesListSlice.reducer
